import { useState } from 'react';
import type { ReactElement } from 'react';

import { LottieAssets } from '@/config/lottieAssets';
import { seekLottie, useAnimationController, useLottie } from '@/utils/useLottie';

/**
 * Перенос `presentation/widgets/mic_button/speech_lottie.dart`.
 *
 * Контроллер ходит не по всей анимации, а между 0.1 и 0.8 — так задумано в
 * Dart (`lowerBound`/`upperBound`), крайние кадры `Speech.json` не показываются.
 */

/** `value: 0.1, lowerBound: 0.1` */
const LOWER_BOUND = 0.1;

/** `upperBound: 0.8` */
const UPPER_BOUND = 0.8;

/** `duration: Duration(seconds: 2)` */
const DURATION_MS = 2000;

/**
 * Собственный размер композиции `Speech.json` — 100×100.
 *
 * Во Flutter `LottieBuilder.asset` без width/height рисует анимацию в её
 * собственном размере, пока он влезает в родителя (в кнопке это `200.w`).
 * `lottie-web` так не умеет — размер задаёт контейнер, поэтому повторяем те
 * же 100 логических пикселей, а `max-*: 100%` повторяет `BoxFit.contain`,
 * если места окажется меньше.
 */
const COMPOSITION_SIZE_PX = 100;

export function SpeechLottie(): ReactElement {
  const [forward, setForward] = useState(true);
  const { containerRef, animationRef } = useLottie({
    animationData: LottieAssets.speech,
  });

  useAnimationController({
    forward,
    durationMs: DURATION_MS,
    lowerBound: LOWER_BOUND,
    upperBound: UPPER_BOUND,
    // `_onAnimationStatusChanges`: у границы разворачиваемся к другой границе.
    onCompleted: () => setForward((value) => !value),
    onTick: (progress) => seekLottie(animationRef.current, progress),
  });

  return (
    <div
      ref={containerRef}
      style={{
        width: COMPOSITION_SIZE_PX,
        height: COMPOSITION_SIZE_PX,
        maxWidth: '100%',
        maxHeight: '100%',
      }}
    />
  );
}
